var map = {
	"./ic_btc_40.svg": 491,
	"./ic_dai_40.svg": 492,
	"./ic_eth_40.svg": 341,
	"./ic_frax_40.svg": 493,
	"./ic_link_40.svg": 494,
	"./ic_uni_40.svg": 495,
	"./ic_usdc_40.svg": 496,
	"./ic_usdt_40.svg": 497,
	"./ic_weth_40.svg": 498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 608;